import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AnimatedRoutes from "./components/AnimatedRoutes";
import "./index.css";
import ScrollToTop from "./components/ScrollToTop";
import StickyMobileCTA from "./components/StickyMobileCTA";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

// Initialize i18n before rendering
import "./lib/i18n";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Toaster />
        <Sonner />
        <ScrollToTop />
        <StickyMobileCTA />
        <AnimatedRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
